export default {
  contract_id: "Contract ID",
  unpaid: "Onbetaald",
  paid: "Betaald",
  reception: "Receptie",
  check_in: "Inchecken",
  check_out: "Uitchecken",
  active: "Actief",
  passed: "Voorbij",
  expected: "Verwacht",
  inactive: "Inactief",
  reception_today: "Receptie vandaag",
  checkin: {
    fill_in: "Vul de gastgegevens in",
    type: "Type gast",
    private: "Privé",
    business: "Bedrijf",
    company_name: "Bedrijfsnaam",
    company_vat: "BTW-nummer",
    company_po: "PO-nummer",
    optional: "optioneel",
    gender: "Geslacht",
    first_name: "Voornaam",
    last_name: "Achternaam",
    street: "Straat",
    zip: "Postcode",
    phone_number: "Telefoonnummer",
    email: "E-mail",
    country: "Land",
    city: "Stad",
    continue: "Ga verder",
    vat_hint: "Vul je btw-nummer in en verlaat het veld om het te valideren.",
    validate_vat: "BTW valideren",
    vat_verified: "BTW gevalideerd",
    vat_invalid: "Ongeldig btw-nummer",
    vat_enter_valid: "Vul een geldig btw-nummer in",
    vat_verified_no_data_manual: "Het BTW-nummer is geldig, maar er werden geen bedrijfsgegevens teruggegeven. Gelieve deze manueel in te vullen.",
    update_success: "Je gast- en contactgegevens zijn succesvol bijgewerkt.",
    update_guest_only_contact_sales: "Je gastgegevens zijn bijgewerkt, maar je contactgegevens konden niet worden aangepast omdat er al facturen bestaan. Neem contact op met sales als je contactgegevens nog moeten worden gewijzigd."
  },
  options: {
    options: "Opties",
    select_additional: "Selecteer extra opties",
    breakfast_select_dates: "Selecteer ontbijtdata",
    total_price: "Totale prijs",
    guests: "Gasten",
    nights: "Nachten",
    cancel: "Annuleren",
    confirm: "Bevestigen"
  },
  overview: {
    overview: "Overzicht",
    name: "Naam",
    address: "Adres",
    phone: "Telefoon",
    email: "E-mail",
    invoice_lines: "Factuurregels",
    removed_options: "Verwijderde opties",
    added_options: "Nieuw toegevoegde opties",
    continue_pay_later: "Ga verder & betaal later",
    contract: "Contract",
    guest_info: "Gastinformatie",
    total_pay_today: "Totaal te betalen vandaag: ",
    confirm_and_pay: "Bevestigen & Nu betalen",
    terms_and_conditions: "Algemene voorwaarden",
    accept_terms_and_conditions: "Ik accepteer de algemene voorwaarden",
    select_method: "Selecteer een betaalmethode om verder te gaan.",
    accept_terms_required: "Je moet de algemene voorwaarden accepteren om verder te gaan.",
    invoice_lines_due_today: "Openstaand bedrag",
    paid_already: "Reeds betaald",
    option_changes: "Optiewijzigingen",
    prepaid_balance_used: "Vooruitbetaald saldo gebruikt"
  },
  passport: {
    passport_scanner: "Paspoortscanner",
    legal_1: "Vanwege wettelijke vereisten moeten we uw paspoort scannen ter verificatie.",
    legal_2: "Upload een duidelijke foto van de zijde met de Machine Readable Zone (MRZ). Het bestaat uit twee of drie regels cijfers, letters en symbolen. Deze informatie is cruciaal voor de authenticatie van uw paspoort.",
    mrz_look_like: "Hoe ziet een MRZ eruit?",
    mrz_example: "MRZ-voorbeeld",
    close: "Sluiten",
    upload_passport: "Upload een pasfoto",
    warning_overwrite: "Waarschuwing: het uploaden van een nieuw paspoort zal uw huidige paspoort overschrijven.",
    rejected: "Uw paspoort is afgewezen.",
    reason: "Reden: ",
    overwrite_passport: "Paspoort overschrijven",
    process_passport: "Paspoort verwerken",
    passport_data: "Paspoortgegevens",
    gender: "Geslacht",
    nationality: "Nationaliteit",
    first_name: "Voornaam",
    last_name: "Achternaam",
    is_data_correct: "Zijn de paspoortgegevens correct?",
    yes: "Ja",
    no: "nee",
    password_approved: "Paspoort goedgekeurd",
    awaiting_approval: "In afwachting van handmatige paspoortcontrole door het verkoopteam",
    failed_to_process: "Kan het paspoort niet verwerken. Zorg ervoor dat de MRZ duidelijk zichtbaar is.",
    passport_confirmation: "Paspoortbevestiging",
    picture_correct: "Foto is correct",
    correct_picture_wrong_data: "De afbeelding die je hebt geüpload is correct, maar de gegevens worden verkeerd gelezen: ",
    sales_team_manual_lookup: "ons verkoopteam zal deze foto handmatig inspecteren en de juiste gegevens invullen.",
    upload_new_picture: "Nieuwe foto uploaden",
    remove_picture_upload_new: "De huidige foto wordt verwijderd en u kunt een nieuwe pasfoto uploaden.",
    enter_now: "Ik zal nu mijn paspoort scannen met een foto.",
    enter_manually: "Ik vul mijn paspoortgegevens handmatig in.",
    provide_at_checkin: "Ik toon mijn paspoort bij het inchecken",
    provide_at_checkin_during_hours: "Ik zal mijn paspoort tonen tijdens de receptie-uren tussen [checkin_time] en [checkout_time] bij het inchecken.",
    enter_passport_data: "Vul je paspoort- of ID-gegevens in",
    birth_date: "Geboortedatum",
    id_number: "Documentnummer",
    submit: "Indienen",
    document_number_help_title: "Waar vind je je documentnummer?",
    document_number_help_belgian_eid_label: "Belgische identiteitskaart (eID)",
    document_number_help_belgian_eid_text: "Het documentnummer staat op de achterkant van de kaart in de machineleesbare zone (MRZ). Zoek naar de lijn die begint met IDBEL; het nummer volgt daarna.",

    document_number_help_belgian_passport_label: "Belgisch paspoort",
    document_number_help_belgian_passport_text: "Het documentnummer staat op de identiteitsgegevenspagina, meestal rechtsboven.",

    document_number_help_other_label: "Andere nationaliteiten",
    document_number_help_other_text: "Het documentnummer staat meestal op de identiteitsgegevenspagina van je paspoort of ID-kaart, aangeduid als 'Documentnr.', 'Paspoortnr.' of iets gelijkaardigs.",
    ok: "OK"

  },
  key_pickup: {
    key_pickup_instructions: "Instructies voor het ophalen van de sleutel",
    gate_code: "Poortcode: ",
    vault_code: "Kluiscode: ",
    check_in: "U kunt inchecken bij onze bemande receptie op [arrival_date] tussen [checkin_time] en [checkout_time]",
    late_arrival_notice: "Let op: Aankomst na [checkin_day] of een vroege check-in geboekt?",
    follow_instructions: "Volg dan de volgende instructies: ",
    access_entrance: "Om de toegangshal te betreden, voert u code ",
    entrance_description: "In de toegangshal ziet u de kluis waar u de sleutel van uw kamer en wat informatie zult vinden.",
    code_safe: "De code voor deze kluis is ",
    safe_instructions: "Draai het slot van de kluis naar rechts om de deur te openen/links om weer te sluiten. ",
    inside_envelope_letter: "Binnenin vindt u een enveloppe met letter ",
    personal_envelope: ", dit is uw persoonlijke enveloppe. ",
    inside_envelope: "Binnenin vindt u een enveloppe met ",
    your_name: "UW NAAM ",
    key_document_inside: "Uw sleutel met kamernummer en document bevinden zich binnenin deze enveloppe, samen met de contactgegevens. ",
    contact_residence: "In geval van problemen kunt u contact opnemen met de residentiebeheerder op het volgende noodnummer: ",
    complete_checkin_for_instructions: "Voltooi uw check-in om toegang te krijgen tot uw sleutelafhaalinstructies.",
    instructions_on_arrival_day: "Op de dag van aankomst vindt u hier uw incheckinstructies.",
    show_qr: "Toon QR-code"
  },
  qr_code: {
    title: "Reservatie QR-code",
    hint: "Gebruik deze QR-code wanneer nodig.",
    not_available: "QR-code is niet beschikbaar voor deze reservatie.",
    load_failed: "De QR-code kon niet geladen worden."
  }


}
